import { render, staticRenderFns } from "./FieldSettings.vue?vue&type=template&id=2252ca65&"
import script from "./FieldSettings.vue?vue&type=script&lang=js&"
export * from "./FieldSettings.vue?vue&type=script&lang=js&"
import style0 from "./FieldSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports